import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { AddSeasonOfficialRole } from "~pages/Officials/SeasonOfficialsListPage/types/seasonOfficialRole.ts";

export const useAddSeasonOfficialRole = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<unknown, Error, AddSeasonOfficialRole>({
    mutationFn: async (body) =>
      await request(`${sport}/o/${organizationId}/roles`, {
        method: "POST",
        body,
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["roles", sport, organizationId],
      });
    },
  });
};
